import { AgentFileUploadSchema, GATEWAY_MODELS } from 'models'

/**
 * Every model an agent can be set to, for a surface with no catalog to read:
 * the widget and the document dialogs, which run on the gateway and have no
 * organization to ask. Everything else takes the catalog, which also carries
 * the names, the prices and the endpoint models.
 */
export const MODELS: readonly string[] = GATEWAY_MODELS

export const DEFAULT_TEMPERATURE = 0.6
export const DEFAULT_PROMPT = ''
export const DEFAULT_LIMIT = 5
export const FILE_UPLOAD_DEFAULTS = AgentFileUploadSchema.parse({})
